module.exports = __webpack_public_path__ + "media/driving_style_de_ipad_new.d2bf5eea.mp4";